import {Component, input, InputSignal, signal, WritableSignal, ChangeDetectionStrategy} from '@angular/core';
import {DefaultIcon} from '../../../types/icons/default-icon.type';
import {ICONS} from '../../../constants/icons/icons.constants';
import {ImageComponent} from '../../image/image.component';
import {IconComponent} from '../../icon/icon.component';

@Component({
    selector: 'app-virtual-scroll-list-item-icon',
    imports: [
        ImageComponent,
        IconComponent
    ],
    templateUrl: './virtual-scroll-list-item-icon.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./virtual-scroll-list-item-icon.component.css']
})
export class VirtualScrollListItemIconComponent {
    public url: InputSignal<string> = input.required<string>();
    public defaultIcon: InputSignal<DefaultIcon> = input<DefaultIcon>(ICONS.DOCUMENT);
    public alt: InputSignal<string> = input.required<string>();
    protected isLoaded: WritableSignal<boolean> = signal(false);
    protected hasError: WritableSignal<boolean> = signal(false);
    protected height: number = 30;
    protected width: number = 30;

    public iconImageHasLoaded(): void {
        this.isLoaded.set(true);
    }

    public iconImageHasError(): void {
        this.hasError.set(true);
    }
}
